export default "__VITE_ASSET__D6UZ4m2c__"